import * as React from 'react';
import { ModalWindow } from '../../../../modal';
import { Checkbox } from '../../../../checkbox';
import { Button } from '../../../../button';
import { useDeviceType } from '../../../../responsive';
import { getStyles } from './styles';
import { useMultiSelectMobileModalController } from './hooks/useMultiSelectMobileModalController';
import { generateDataTestId } from '../../../../internal/utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function MultiSelectMobileModal(props) {
  const {
    open,
    onClose,
    options,
    onChange,
    title,
    name,
    dataTestId
  } = props;
  const deviceType = useDeviceType();
  const styles = getStyles(deviceType);
  const {
    value,
    handleOptionChange,
    allOptionLabel,
    handleAllOptionChange
  } = useMultiSelectMobileModalController(props);
  const handleApply = () => {
    if (value !== props.value && onChange) {
      onChange(value || []);
    }
    onClose();
  };
  const bindHandleOptionChange = index => () => {
    return handleOptionChange(index);
  };
  return /*#__PURE__*/_jsx(ModalWindow, {
    fixed: true,
    width: 648,
    open: open,
    onClose: onClose,
    title: title,
    footer: /*#__PURE__*/_jsxs("div", {
      className: styles['footer-buttons'],
      children: [/*#__PURE__*/_jsx(Button, {
        theme: "fill_secondary",
        onClick: onClose,
        children: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C"
      }), /*#__PURE__*/_jsx(Button, {
        theme: "fill_primary",
        onClick: handleApply,
        children: "\u041F\u0440\u0438\u043C\u0435\u043D\u0438\u0442\u044C"
      })]
    }),
    children: /*#__PURE__*/_jsxs("div", {
      className: styles['content'],
      role: "listbox",
      "data-testid": generateDataTestId(dataTestId, ['items']),
      children: [allOptionLabel && /*#__PURE__*/_jsx(Checkbox, {
        value: "allOption",
        checked: (value === null || value === void 0 ? void 0 : value.length) === options.length,
        label: allOptionLabel,
        onChange: handleAllOptionChange,
        role: "option",
        dataTestId: generateDataTestId(dataTestId, ['allOption'])
      }), options.map((option, index) => {
        const optionValue = option.value;
        const key = String(optionValue);
        return /*#__PURE__*/_jsx(Checkbox, {
          name: name,
          value: key,
          checked: (value || []).includes(optionValue),
          label: option.label,
          description: option.description,
          onChange: bindHandleOptionChange(index),
          role: "option",
          dataTestId: generateDataTestId(dataTestId, [key])
        }, key);
      })]
    })
  });
}